"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("../api/WickedApiClient");
var LocalModels_1 = require("../api/LocalModels");
var WickedApiClient_2 = require("../api/WickedApiClient");
var http_1 = require("@angular/common/http");
var rxjs_1 = require("rxjs");
var ngx_cookie_service_1 = require("ngx-cookie-service");
var geolocation_service_1 = require("./geolocation.service");
var searchroute_service_1 = require("./searchroute.service");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var i2 = require("@angular/common/http");
var i3 = require("ngx-cookie-service");
var i4 = require("./geolocation.service");
var ViewMode;
(function (ViewMode) {
    ViewMode["ACTIVE"] = "ACTIVE";
    ViewMode["EXPIRED"] = "EXPIRED";
    ViewMode["ALL"] = "ALL";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
var AdvertisementService = /** @class */ (function () {
    function AdvertisementService(advClient, http, bannersCLient, cookieService, geolocationClient) {
        var _this = this;
        this.advClient = advClient;
        this.http = http;
        this.bannersCLient = bannersCLient;
        this.cookieService = cookieService;
        this.geolocationClient = geolocationClient;
        this.services = null;
        this.categories = [];
        this.regions = [];
        this._bannersEnabled = false;
        this._useBannerProviders = null;
        this.singleRegions = [];
        this.subRegionsByRegion = new Map();
        this.regionsLoading = false;
        this._searchInAction = false;
        this.searchInActionChanged = new rxjs_1.BehaviorSubject(false);
        this.resultListUpdate = new rxjs_1.Subject();
        this.searchDataStandard = new searchData(geolocationClient);
        this.searchDataUserAdv = new searchData();
        this.getGoogleApiKey();
        this.getBlogUrl();
        this.bannersCLient.getBannersEnabled().subscribe(function (v) {
            _this.bannersEnabled = (v == "True") ? true : false;
            _this.bannersCLient.getUseBannerProviders().subscribe(function (v) {
                _this.useBannerProviders = (v == "True") ? true : false;
            });
        });
        //  this.searchActionForUser();
    }
    Object.defineProperty(AdvertisementService.prototype, "bannersEnabled", {
        get: function () {
            return this._bannersEnabled;
        },
        set: function (value) {
            this._bannersEnabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvertisementService.prototype, "useBannerProviders", {
        get: function () {
            return this._useBannerProviders;
        },
        set: function (value) {
            this._useBannerProviders = value;
        },
        enumerable: true,
        configurable: true
    });
    AdvertisementService.prototype.getGoogleApiKey = function () {
        var _this = this;
        this.advClient.getGoogleKey().subscribe(function (v) {
            _this.googleApiKey = v;
        });
    };
    AdvertisementService.prototype.getBlogUrl = function () {
        var _this = this;
        this.advClient.getBlogUrl().subscribe(function (v) {
            _this.blogURL = v;
        });
    };
    AdvertisementService.prototype.getLocationDataByZipCode = function (zipcode) {
        var url = "https://maps.googleapis.com/maps/api/geocode/json?key=" + this.googleApiKey + "&components=postal_code:" + zipcode;
        return this.http.get(url);
    };
    AdvertisementService.prototype.getCategoriesObservable = function (forceApi) {
        if (forceApi === void 0) { forceApi = false; }
        if (!forceApi && CATEGORIES != undefined) {
            return rxjs_1.of(CATEGORIES);
        }
        else {
            return this.advClient.getCategories();
        }
    };
    AdvertisementService.prototype.getCategories = function (force) {
        var _this = this;
        if (force === void 0) { force = false; }
        return new Promise(function (rs, rj) {
            if (!force && CATEGORIES != undefined) {
                rs(CATEGORIES);
            }
            else {
                _this.services.progress = true;
                if (_this.categories && _this.categories.length > 0) {
                    rs(_this.categories);
                    _this.services.progress = false;
                }
                else {
                    _this.advClient.getCategories().subscribe(function (result) {
                        _this.categories = result;
                        rs(result);
                        _this.services.progress = false;
                    });
                }
            }
        });
    };
    AdvertisementService.prototype.delete = function (advertisementId) {
        var _this = this;
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            _this.advClient.delete(new WickedApiClient_1.AdveristmentDeleteModel({ advertisementId: advertisementId })).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.repost = function (repostModel) {
        var _this = this;
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            _this.advClient.repost(repostModel).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.getRegionsOnly = function () {
        var _this = this;
        if (this.regionsLoading == true) {
            return this.singleRegions;
        }
        else {
            if (this.singleRegions.length == 0) {
                this.regionsLoading = true;
                this.advClient.getRegionsOnly().subscribe(function (result) {
                    result.forEach(function (x) {
                        _this.singleRegions.push(x);
                    });
                    _this.regionsLoading = false;
                });
            }
            return this.singleRegions;
        }
    };
    AdvertisementService.prototype.getSubRegionsForRegionPromise = function (regionId) {
        var _this = this;
        return new Promise(function (rs, rj) {
            if (!regionId) {
                rs([]);
            }
            else {
                if (_this.subRegionsByRegion.has(regionId) && _this.subRegionsByRegion.get(regionId).length > 0) {
                    rs(_this.subRegionsByRegion.get(regionId));
                }
                else
                    _this.advClient.getChildrenSubRegions(regionId).subscribe(function (res) {
                        var subRegions = [];
                        res.forEach(function (r) {
                            subRegions.push(r);
                        });
                        _this.subRegionsByRegion.set(regionId, subRegions);
                        rs(res);
                    });
            }
        });
    };
    AdvertisementService.prototype.getSubRegionsByRegionId = function (regionId) {
        if (!regionId) {
            return [];
        }
        if (this.subRegionsByRegion.has(regionId)) {
            return this.subRegionsByRegion.get(regionId);
        }
        else {
            var subRegions_1 = [];
            this.subRegionsByRegion.set(regionId, subRegions_1);
            this.advClient.getChildrenSubRegions(regionId).subscribe(function (res) {
                res.forEach(function (r) {
                    subRegions_1.push(r);
                });
            });
            return subRegions_1;
        }
    };
    AdvertisementService.prototype.getRegionsObservable = function () {
        return this.advClient.getRegionsOnly();
    };
    AdvertisementService.prototype.getRegionsOnlyPromise = function () {
        var _this = this;
        return new Promise(function (rs, rj) {
            if (!_this.regionsLoading && _this.regions.length == 0) {
                _this.regionsLoading = true;
                _this.advClient.getRegionsOnly().subscribe(function (result) {
                    _this.regionsLoading = false;
                    result.forEach(function (x) {
                        _this.singleRegions.push(x);
                    });
                    _this.regionsLoading = false;
                    rs(_this.singleRegions);
                });
            }
        });
    };
    AdvertisementService.prototype.getSubRegionNameById = function (regionId, subregionId) {
        var subRegions = this.getSubRegionsByRegionId(regionId).filter(function (s) { return s.subRegionId == subregionId; });
        if (subRegions != null && subRegions.length > 0) {
            return subRegions[0].name;
        }
        else
            return "";
    };
    AdvertisementService.prototype.getRegionNameById = function (id) {
        var region = this.singleRegions.filter(function (v) {
            return v.regionId == id;
        });
        return region[0];
    };
    AdvertisementService.prototype.create = function (userNick, title, content, region, subregion, postalCode, casualDating, relationShips, publish, age, images, isPremium, isThirdParty) {
        var _this = this;
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            var req = new WickedApiClient_1.AdveristmentCreateModel();
            var imagesToSave = images.map(function (x, index) {
                var r = new WickedApiClient_1.DTOAdvertisementImage();
                r.init(x);
                return r;
            });
            req.init({
                userNick: userNick,
                advertisementCategoryId: relationShips,
                casualDating: casualDating,
                content: content,
                images: imagesToSave,
                published: publish,
                regionId: region,
                subRegionId: subregion,
                title: title,
                zipCode: postalCode,
                age: age,
                userId: _this.services.userService.getUserId(),
                isDemo: false,
                seen: false,
                seenAdmin: false,
                isPremium: isPremium,
                isThirdParty: isThirdParty
            });
            _this.advClient.create(req).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.update = function (manageId, id, userId, userNick, title, content, region, subregion, postalCode, casualDating, relationShips, publish, age, images, isPremium, isThirdParty) {
        var _this = this;
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            var req = new WickedApiClient_1.AdveristmentUpdateModel();
            var imagesToSave = images.map(function (x, index) {
                var r = new WickedApiClient_1.DTOAdvertisementImage();
                r.init(x);
                return r;
            });
            req.init({
                manageId: manageId,
                advertisementId: id,
                userId: userId,
                userNick: userNick,
                advertisementCategoryId: relationShips,
                casualDating: casualDating,
                content: content,
                images: imagesToSave,
                published: publish,
                regionId: region,
                subRegionId: subregion,
                title: title,
                age: age,
                seen: false,
                seenAdmin: false,
                isPremium: isPremium,
                isThirdParty: isThirdParty,
                zipCode: postalCode,
                isDemo: false
            });
            _this.advClient.update(req).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.getAdvertisementData = function (advertisementId) {
        var _this = this;
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            _this.advClient.getAdvertisementData(advertisementId).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.get = function (id, conversationKey) {
        var _this = this;
        if (conversationKey === void 0) { conversationKey = null; }
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            var req = new WickedApiClient_1.AdveristmentGetModel();
            req.init({
                byId: id,
                conversationKey: conversationKey
            });
            _this.advClient.get(req).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.getByManageId = function (manageId) {
        var _this = this;
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            var req = new WickedApiClient_1.AdveristmentGetModel();
            req.init({
                manageId: manageId
            });
            _this.advClient.get(req).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.getAll = function () {
        var _this = this;
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            var req = new WickedApiClient_1.AdveristmentGetModel();
            req.init(_this.searchDataStandard.currentSearchRule);
            _this.advClient.get(req).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    AdvertisementService.prototype.getAllFromUser = function (viewMode) {
        var _this = this;
        if (viewMode === void 0) { viewMode = undefined; }
        this.services.progress = true;
        return new Promise(function (rs, rj) {
            var req = new WickedApiClient_1.AdveristmentGetModel();
            if (viewMode) {
                _this.searchDataUserAdv.currentSearchRule.showActive = (viewMode == ViewMode.ACTIVE || viewMode == ViewMode.ALL);
                _this.searchDataUserAdv.currentSearchRule.showExpired = (viewMode == ViewMode.EXPIRED || viewMode == ViewMode.ALL);
            }
            else {
                _this.searchDataUserAdv.currentSearchRule.showActive = true;
                _this.searchDataUserAdv.currentSearchRule.showExpired = true;
            }
            req.init(_this.searchDataUserAdv.currentSearchRule);
            _this.advClient.get(req).subscribe(function (result) {
                _this.services.progress = false;
                if (result.error) {
                    rj(result.error);
                }
                else {
                    rs(result);
                }
            });
        });
    };
    Object.defineProperty(AdvertisementService.prototype, "searchInAction", {
        get: function () {
            return this._searchInAction;
        },
        set: function (value) {
            this.searchInActionChanged.next(value);
            this._searchInAction = value;
        },
        enumerable: true,
        configurable: true
    });
    AdvertisementService.prototype.performSearchActionWithoutNavigateToSearchResult = function () {
        this.searchAction(false);
    };
    AdvertisementService.prototype.clearSearchData = function () {
        this.searchDataStandard = new searchData();
        this.searchDataUserAdv = new searchData();
    };
    AdvertisementService.prototype.searchAction = function (navigateToSearchResult, navigateURL) {
        var _this = this;
        if (navigateToSearchResult === void 0) { navigateToSearchResult = true; }
        if (navigateURL === void 0) { navigateURL = ""; }
        this.searchInAction = true;
        var searchDataExpiresAt = new Date().getDate() + 2;
        this.getAll().then(function (result) {
            _this.services.advService.searchDataStandard.RegionShortName = result.regionShortName;
            _this.services.advService.searchDataStandard.SubregionName = result.subRegionName;
            _this.services.advService.searchDataStandard.ClosestSubregionNameIfNoResult = result.closestSubregionNameIfNoResult;
            //this.services.advService.searchDataStandard.currentSearchRule.nonDemoOnly = false;
            _this.searchDataStandard.resultList = result.adveristments.map(function (r) {
                var res = new LocalModels_1.DTOAdvertisementEx();
                res.init(r);
                return r;
            });
            _this.searchDataStandard.resultCount = result.totalResultsCount;
            _this.resultListUpdate.next();
            if (navigateToSearchResult) {
                _this.services.route.navigate([navigateURL]);
            }
            _this.searchInAction = false;
        });
    };
    AdvertisementService.prototype.searchActionForUser = function (viewMode) {
        var _this = this;
        if (viewMode === void 0) { viewMode = undefined; }
        this.searchInAction = true;
        this.getAllFromUser(viewMode).then(function (v) {
            _this.searchDataUserAdv.RegionShortName = v.regionShortName;
            _this.searchDataUserAdv.SubregionName = v.subRegionName;
            _this.searchDataUserAdv.ClosestSubregionNameIfNoResult = v.closestSubregionNameIfNoResult;
            _this.searchDataUserAdv.resultList = v.adveristments.map(function (r) {
                var res = new LocalModels_1.DTOAdvertisementEx();
                res.init(r);
                return r;
            });
            _this.searchDataUserAdv.resultCount = v.totalResultsCount;
            _this.resultListUpdate.next();
            _this.searchInAction = false;
        });
    };
    AdvertisementService.prototype.markAdvertisementAsSeen = function (advertisementId, isAdmin) {
        var _this = this;
        return new Promise(function (rs, rj) {
            var model = new WickedApiClient_1.AdvertisementMarkAsSeenRequestModel();
            model.advertisementId = advertisementId;
            model.isAdmin = isAdmin;
            _this.advClient.markAsSeenByDemo(model).subscribe(function (result) {
                if (result.error) {
                    rj(result.error);
                }
                else
                    rs();
            });
        });
    };
    AdvertisementService.prototype.CreateAdWriteInformation = function (data) {
        return this.advClient.createAdWriteInformation(data).toPromise();
    };
    AdvertisementService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdvertisementService_Factory() { return new AdvertisementService(i0.ɵɵinject(i1.AdveristmentsClient), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i1.BannersClient), i0.ɵɵinject(i3.CookieService), i0.ɵɵinject(i4.GeolocationService)); }, token: AdvertisementService, providedIn: "root" });
    return AdvertisementService;
}());
exports.AdvertisementService = AdvertisementService;
var searchData = /** @class */ (function () {
    function searchData(geolocationClient) {
        var _this = this;
        if (geolocationClient === void 0) { geolocationClient = null; }
        this.resultList = [];
        this._currentSearchRule = {
            pageNumber: 0,
            pageSize: 24,
            casualDating: false,
            showExpired: true,
            showActive: true
        };
        this.isRouteSearchTrigger = new rxjs_1.ReplaySubject(1);
        this.currentSearchRuleChanged = new rxjs_1.ReplaySubject(1);
        this.geolocationSearchRuleChanged = new rxjs_1.ReplaySubject(1);
        this._resultCount = 0;
        this._expiredCount = 0;
        this._activeCount = 0;
        this._closestSubregionNameIfNoResult = "";
        this._regionShortName = "";
        this.RegionShortNameChanged = new rxjs_1.Subject();
        this._subregionName = "";
        this.SubregionNameChanged = new rxjs_1.Subject();
        if (geolocationClient != null && !this.isSearchRoute()) {
            geolocationClient.GetGeolocationSearchModel().subscribe(function (response) {
                _this._currentSearchRule = response;
                var data = __assign({}, _this._currentSearchRule);
                data._type = "geolocation";
                _this.currentSearchRuleChanged.next(data);
            });
        }
    }
    searchData.prototype.isSearchRoute = function () {
        var regex = new RegExp(searchroute_service_1.RegexSearchList, "gi");
        var paramsUrl = window.location.pathname.replace("/", "");
        var regexMatch = regex.exec(paramsUrl);
        if (regexMatch != null && regexMatch.groups != null) {
            return true;
        }
        else {
            return false;
        }
    };
    Object.defineProperty(searchData.prototype, "currentSearchRule", {
        get: function () {
            return this._currentSearchRule;
        },
        set: function (value) {
            this._currentSearchRule = value;
            this.currentSearchRuleChanged.next(this._currentSearchRule);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(searchData.prototype, "expiredCount", {
        get: function () {
            return this._expiredCount;
        },
        set: function (value) {
            this._expiredCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(searchData.prototype, "activeCount", {
        get: function () {
            return this._activeCount;
        },
        set: function (value) {
            this._activeCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(searchData.prototype, "resultCount", {
        get: function () {
            return this._resultCount;
        },
        set: function (value) {
            this._resultCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(searchData.prototype, "ClosestSubregionNameIfNoResult", {
        get: function () {
            return this._closestSubregionNameIfNoResult;
        },
        set: function (value) {
            this._closestSubregionNameIfNoResult = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(searchData.prototype, "RegionShortName", {
        get: function () {
            return this._regionShortName;
        },
        set: function (value) {
            this._regionShortName = value;
            this.RegionShortNameChanged.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(searchData.prototype, "SubregionName", {
        get: function () {
            return this._subregionName;
        },
        set: function (value) {
            this._subregionName = value;
            this.SubregionNameChanged.next(value);
        },
        enumerable: true,
        configurable: true
    });
    return searchData;
}());
exports.searchData = searchData;
